import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import QuotableGroup from "./quotable/QuotableGroup";
import QuotableTest from "./quotable/QuotableTest";
import Quotables from "./quotable/Quotables";
import QuotableTableWrapper from "./quotable/QuotableTableWrapper";

// recursive search down tree
function visibleInChildren(quotable, regexp) {
  if (quotable.type == "group") {
    if (regexp.test(quotable.name)) return true;
    return quotable.quotables.some(q => visibleInChildren(q, regexp));
  } else {
    return regexp.test(quotable.test_name) || regexp.test(quotable.technique_name);
  }
}

function visible(quotable, search) {
  if (!search) {
    return true;
  } else {
    const regexp = new RegExp(search, "i");
    return visibleInChildren(quotable, regexp);
  }
}

function QuotablesGroup({
  quotables,
  disabledIds = [],
  selectedIds = [],
  onChangeIds,
  hideSearch = false,
  selectQuoteItems = false,
  selectSampleQuotables = false,
  canSelect = quotable => quotable.can_add_to_sample,
  renderPrice = quotable => quotable.price,
  hideCheckbox = false
}) {
  const [search, setSearch] = useState(null);
  const isDisabled = quotable => disabledIds.includes(selectableId(quotable));
  const isSelected = quotable => selectedIds.includes(selectableId(quotable));
  const isVisible = quotable => visible(quotable, search);

  var selectableProperty;
  if (selectQuoteItems) selectableProperty = "quote_item_id";
  if (selectSampleQuotables) selectableProperty = "sample_quotable_id";

  const selectableId = quotable => quotable[selectableProperty];

  const toggleSelection = quotable => {
    if (quotable.disabled) {
      alert(
        "You cannot add this item because it is missing the required dilutions in your specification. Please contact the laboratory if you need this."
      );
      return;
    }
    const id = selectableId(quotable);
    if (disabledIds.includes(id)) return;
    if (selectedIds.includes(id)) {
      onChangeIds(selectedIds.filter(selectedId => selectedId !== id));
    } else {
      onChangeIds(selectedIds.concat(id));
    }
  };

  const renderCheckbox = quotable =>
    hideCheckbox
      ? null
      : canSelect(quotable) && (
          <input
            type="checkbox"
            disabled={isDisabled(quotable) || quotable.disabled}
            checked={isSelected(quotable)}
            onChange={() => toggleSelection(quotable)}
          />
        );

  return (
    <div>
      {!hideSearch && (
        <div className="pull-right" style={{ marginBottom: 10 }}>
          <input
            className="form-control input-sm"
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder={I18n.t("search")}
          />
        </div>
      )}
      <QuotableTableWrapper>
        <Quotables
          quotables={quotables}
          isDisabled={isDisabled}
          isVisible={isVisible}
          renderCheckbox={renderCheckbox}
          renderPrice={renderPrice}
        />
      </QuotableTableWrapper>
    </div>
  );
}

export default observer(QuotablesGroup);
